import React from 'react'

const CheckoutContext = React.createContext({
  checkout: {},
  setCheckout: () => {},
})

export default CheckoutContext
